import { ImportHistoryApi } from '../../../../../api/importHistoryApi';
import { AdvancedOptions, CalculationType } from '../../../../../interfaces/Mapping';
import {
	SovosButton,
	SovosFormControl,
	SovosFormLabel,
	SovosMenuItem,
	SovosSelect,
	SovosTypography,
} from 'mosaic-react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const SovosFormControlWrapperStyle = { width: '33.33%', paddingRight: 20, marginTop: 20 };
const SovosFormControlSeparatorsWrapperStyle = { ...SovosFormControlWrapperStyle, display: 'none' };
const SovosFormControlStyle = { width: '100%' };
const optionsDateFormat = [
	'DD/MM/YYYY',
	'MM/dd/yy',
	'MM/dd/yyyy',
	'yyyyMMdd',
	'MMM-dd-yy',
	'yyyy-MM-dd',
	'MMM dd, yyyy',
];
const optionsThousandsSeparator = [
	{ value: '', label: 'None' },
	{ value: ',', label: 'Comma' },
	{ value: '.', label: 'Period' },
];
const optionsDecimalSeparator = [
	{ value: '.', label: 'Period' },
	{ value: ',', label: 'Comma' },
];

const optionsTransactionType = [
	{ value: '1', label: 'Sale' },
	{ value: '2', label: 'Purchase' },
];

interface AdvancedOptionsProps {
	advancedOptions: AdvancedOptions;
	setAdvancedOptions: Dispatch<SetStateAction<AdvancedOptions>>;
}

const AdvancedOptionsComponent = ({ advancedOptions, setAdvancedOptions }: AdvancedOptionsProps) => {
	const [isShowAdvancedOptions, setIsShowAdvancedOptions] = useState<boolean>(false);
	const [optionsCalculationType, setOptionsCalculationType] = useState<CalculationType[]>([]);

	useEffect(() => {
		ImportHistoryApi.getCalcTypes()
			.then(response => setOptionsCalculationType(response))
			.catch(err => console.log(err));
	}, []);

	return (
		<>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<SovosTypography variant='body1' style={{ fontWeight: 500 }}>
					Advanced Options
				</SovosTypography>
				<SovosButton variant='text' onClick={() => setIsShowAdvancedOptions(!isShowAdvancedOptions)}>
					{isShowAdvancedOptions ? 'Hide' : 'Show'}
				</SovosButton>
			</div>
			{isShowAdvancedOptions && (
				<div style={{ display: 'flex', flexWrap: 'wrap' }}>
					<div style={SovosFormControlWrapperStyle}>
						<SovosFormControl style={SovosFormControlStyle}>
							<SovosFormLabel id='advanced-date-format'>Date format</SovosFormLabel>
							<SovosSelect
								labelId='advanced-date-format'
								value={advancedOptions.dateFormat}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
									setAdvancedOptions(current => ({ ...current, dateFormat: event.target.value }))
								}
								classes={{ SovosSelect: 'custom-style-SovosSelect' }}
							>
								{optionsDateFormat.map(option => (
									<SovosMenuItem value={option} key={option}>
										{option}
									</SovosMenuItem>
								))}
							</SovosSelect>
						</SovosFormControl>
					</div>
					<div style={SovosFormControlSeparatorsWrapperStyle}>
						<SovosFormControl style={SovosFormControlStyle}>
							<SovosFormLabel id='advanced-thousand-separator'>Thousands separator</SovosFormLabel>
							<SovosSelect
								labelId='advanced-thousand-separator'
								value={advancedOptions.thousandSeparator}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
									setAdvancedOptions(current => ({ ...current, thousandSeparator: event.target.value }))
								}
								classes={{ SovosSelect: 'custom-style-SovosSelect' }}
							>
								{optionsThousandsSeparator.map(option => (
									<SovosMenuItem
										value={option.value}
										key={option.value}
										disabled={option.value === advancedOptions.decimalSymbol}
									>
										{option.label}
									</SovosMenuItem>
								))}
							</SovosSelect>
						</SovosFormControl>
					</div>
					<div style={SovosFormControlSeparatorsWrapperStyle}>
						<SovosFormControl style={SovosFormControlStyle}>
							<SovosFormLabel id='advanced-decimal-symbol'>Decimal separator</SovosFormLabel>
							<SovosSelect
								labelId='advanced-decimal-symbol'
								value={advancedOptions.decimalSymbol}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
									setAdvancedOptions(current => ({ ...current, decimalSymbol: event.target.value }))
								}
								classes={{ SovosSelect: 'custom-style-SovosSelect' }}
							>
								{optionsDecimalSeparator.map(option => (
									<SovosMenuItem
										value={option.value}
										key={option.value}
										disabled={option.value === advancedOptions.thousandSeparator}
									>
										{option.label}
									</SovosMenuItem>
								))}
							</SovosSelect>
						</SovosFormControl>
					</div>
					<div style={{ ...SovosFormControlWrapperStyle }}>
						<SovosFormControl style={SovosFormControlStyle}>
							<SovosFormLabel id='advanced-calculation-type'>Calculation type</SovosFormLabel>
							<SovosSelect
								labelId='advanced-calculation-type'
								value={advancedOptions.calculationType}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
									setAdvancedOptions(current => ({ ...current, calculationType: parseInt(event.target.value) }))
								}
								classes={{ SovosSelect: 'custom-style-SovosSelect' }}
							>
								{optionsCalculationType.map(option => (
									<SovosMenuItem value={option.value} key={option.value}>
										<span>{option.label}</span>
									</SovosMenuItem>
								))}
							</SovosSelect>
						</SovosFormControl>
					</div>
					<div style={SovosFormControlWrapperStyle}>
						<SovosFormControl style={SovosFormControlStyle}>
							<SovosFormLabel id='advanced-transaction-type'>Transaction type</SovosFormLabel>
							<SovosSelect
								labelId='advanced-transaction-type'
								value={advancedOptions.transactionType}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
									setAdvancedOptions(current => ({ ...current, transactionType: parseInt(event.target.value) }))
								}
								classes={{ SovosSelect: 'custom-style-SovosSelect' }}
							>
								{optionsTransactionType.map(option => (
									<SovosMenuItem value={option.value} key={option.value}>
										<span>{option.label}</span>
									</SovosMenuItem>
								))}
							</SovosSelect>
						</SovosFormControl>
					</div>
				</div>
			)}
		</>
	);
};

export default AdvancedOptionsComponent;
